/**
 * Punto de entrada. Lee la configuración de runtime y solo entonces arranca.
 *
 * El `import()` DINÁMICO no es estilo: es lo único que ordena las dos cosas.
 * Los imports estáticos de un módulo se evalúan antes de su primera sentencia,
 * y el árbol de `./arranque` llega hasta `@/api`, donde el `BASE` de `http.ts`
 * y el `api` de `api/index.ts` quedan congelados en tiempo de evaluación. Un
 * `await fetch()` escrito aquí arriba llegaría tarde igual.
 *
 * Los estilos SÍ se quedan aquí, en el módulo de entrada, y a propósito: así
 * Vite los emite como un `<link>` del `index.html` en vez de dentro del chunk
 * diferido, y la página no aparece un instante sin estilos mientras se resuelve
 * la configuración.
 */

import '@/styles/console.css'
import '@/styles/shell.css'
import '@/styles/components.css'

import { cargarConfig } from './config/runtime'

void cargarConfig()
  .then(() => import('./arranque'))
  .then((m) => m.arrancar())
